import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addBlog({ commit }, item) {
    return this.$axios.$post('admin/blogs/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeBlog({ commit }, item) {
    return this.$axios.$delete(`admin/blogs/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateBlog({ commit }, item) {
    return this.$axios.$put(`admin/blogs/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchBlog({ commit }, id) {
    return this.$axios.$get(`admin/blogs/${id}`).then((response) => {
      return response.data
    })
  },
  fetchBlogs({ commit }) {
    return this.$axios.$get('admin/blogs').then((response) => {
      commit('load', response.data)
    })
  },
}
